/* eslint-disable canonical/filename-match-regex */
import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import {
    BallonIcon,
    HalfClockIcon,
    HeadsetIcon,
    USPBanner,
    type USPBannerProps,
} from '@jsmdg/yoshi';
import { type TenantConfig } from '../../../shared/types';
import { type ProductDetailContext } from '../../types/types';
import styles from './USPSliderMobile.module.scss';

const getUSPConfig = (isMydays: boolean, tenantConfig: TenantConfig): USPBannerProps => {
    return {
        items: isMydays
            ? [
                  {
                      icon: <BallonIcon size={50} className={styles.icon} />,
                      headline: tenantConfig.uspPrimaryText,
                  },
                  {
                      icon: <HalfClockIcon size={50} className={styles.icon} />,

                      headline: tenantConfig.uspSecondaryText,
                  },
                  {
                      icon: <HeadsetIcon className={styles.icon} size={50} />,
                      headline: tenantConfig.uspTertiaryText,
                  },
              ]
            : [
                  {
                      icon: <BallonIcon size={50} className={styles.icon} />,
                      headline: tenantConfig.uspPrimaryText,
                  },
                  {
                      icon: <HalfClockIcon className={styles.icon} size={50} />,
                      headline: tenantConfig.uspSecondaryText,
                  },
                  {
                      icon: <HeadsetIcon className={styles.icon} size={50} />,
                      headline: tenantConfig.uspTertiaryText,
                  },
              ],

        containerCls: 'mt-4x w-100',
    };
};

const USPSliderMobile = (): JSX.Element => {
    const { isMydays, tenantConfig } = useFragmentContext<ProductDetailContext>();
    const uspConfig = getUSPConfig(isMydays, tenantConfig);

    const updatedItems = uspConfig.items.map(item => {
        const updatedItem = { ...item };

        if (updatedItem.headline) {
            updatedItem.headline = (
                <span className={`${styles.headline}`}>{updatedItem.headline}</span>
            );
        }

        return updatedItem;
    });

    const updatedUspConfig = { ...uspConfig, items: updatedItems };

    return (
        <div className="grid">
            <div className="g-col-6 g-col-xs-12">
                <USPBanner
                    items={updatedUspConfig.items}
                    containerCls={updatedUspConfig.containerCls}
                />
            </div>
        </div>
    );
};

export { USPSliderMobile };
